// extracted by mini-css-extract-plugin
export default {"batch":"styles_batch__akfm1","link":"styles_link__Tmx6D"};